import { format } from 'date-fns'
import * as Sentry from "@sentry/browser";

export const currencyFormat = {
  'USD': {unit: '$', decimal: 2},
  'JPY': {unit: '¥', decimal: 0},
  'TWD': {unit: 'NT$', decimal: 0},
}
export const formatCurrency = (price) => {
  const exchangeRatesData = localStorage.getItem('exchangeRatesData');
  let currency = window.global_values['CURRENCY'];
  let rate = null;

  // 交易對格式 USDJPY,USDTWD
  // 沒有匯率的話就用 USD
  if(exchangeRatesData) {
    rate = JSON.parse(exchangeRatesData).rates[`USD${currency}`]['Exrate']
  } else {
    currency = 'USD'
    rate = 1
  }
  const { unit, decimal } = currencyFormat[currency];
  return `${unit} ${(price * rate).toFixed(decimal)}`
}

export const initExchangeRates = async () => {
  const exchangeRatesData = localStorage.getItem('exchangeRatesData');
  if (!exchangeRatesData || exchangeRatesData.updated_at !== format(new Date(), 'yyyy-MM-dd')) {
    try {
      const response = await fetch('/api/v1/exchange_rates');

      // 在 Redis 還沒有匯率數據時，系統會 fallback 到 USD，404 是預期行為不是錯誤, 不需要記錄到 Sentry
      if (response.status === 404) {
        console.info('Exchange rates not available yet, using default USD currency');
        return;
      }

      // 只記錄真正的伺服器錯誤（5xx）
      if (!response.ok && response.status >= 500) {
        Sentry.captureMessage(`Exchange rate API server error: HTTP ${response.status}`, 'error');
        return;
      }

      // 其他 4xx 錯誤（如 401, 403）也不記錄
      if (!response.ok) {
        console.warn(`Exchange rate API returned ${response.status}, using default currency`);
        return;
      }

      // 成功獲取匯率數據
      if (response.ok) {
        const data = await response.json();
        const today = format(new Date(), 'yyyy-MM-dd');
        localStorage.setItem('exchangeRatesData', JSON.stringify({rates: data, updated_at: today}));
      }
    } catch (error) {
      console.warn('Network error fetching exchange rates:', error.message);
    }
  }
}
